import { render, staticRenderFns } from "./RestaurantDeliveryProviders.vue?vue&type=template&id=4e6713ac&scoped=true&"
import script from "./RestaurantDeliveryProviders.vue?vue&type=script&lang=js&"
export * from "./RestaurantDeliveryProviders.vue?vue&type=script&lang=js&"
import style0 from "./RestaurantDeliveryProviders.vue?vue&type=style&index=0&id=4e6713ac&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e6713ac",
  null
  
)

export default component.exports